module.exports = __webpack_public_path__ + "img/test-caozuocuowu.fb814002.png";